const defaultState = {
  paramsObj: {},
  gameObj: {},
  audioObj: {}
};

const paramsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "GET_PARAMS_SUCCESS": {
      return {
        ...state,
        paramsObj: action.payload.data
      };
    }

    case "GET_AUDIO_PARAMS_SUCCESS": {
      return {
        ...state,
        audioObj: action.payload.data
      };
    }

    case "GET_GAME_DATA_SUCCESS": {
      return {
        ...state,
        gameObj: action?.payload?.data?.tabletop
      };
    }

    case "GET_SUB_GAME_DATA_SUCCESS": {
      return {
        ...state,
        gameObj: action?.payload?.data
      };
    }

    case "EMPTY_GAME_DATA": {
      return {
        ...state,
        gameObj: {}
      };
    }

    default:
      return state;
  }
};

export default paramsReducer;
